import React,{Component} from 'react';
import './KPIPage.css';

import { kpiBanner, logo } from '../../_utils/images';
import Page from '@acri-tools/react-tools/components/Page/Page';
import routes from '../../_utils/routes';
import Footer from '../../components/Footer/Footer';
import Tabs from '@acri-tools/react-tools/components/Tabs/Tabs';
import KPIList from '../../components/KPIList/KPIList';

import { Chart } from 'chart.js';
import Spinner from '@acri-tools/react-tools/components/Spinner/Spinner';
import _data from './data';
import KPIHistory from '../../components/KPIHistory/KPIHistory';
import request from '@acri-tools/react-tools/utils/request';
import { API_URL } from '../../_utils/config';
import { axiosErrorHandler } from '@acri-tools/react-tools/utils/global';
import { format_kpi, KPI_ORDER, PROJECT_START } from '../../_utils/kpi';

interface Props{
}
interface State{
    kpi_definitions?:any
    kpis?:any
    kpi_performance_levels?:any
    loading:boolean,
    months: Array<string>
}

export const dateToString = (date:Date) =>{
    return`${date.getUTCFullYear()}-${(date.getUTCMonth() + 1).toString().padStart(2, '0')}`;
}

export default class KPIPage extends Component<Props, State> {
    
    constructor(props:Props){
        super(props);
        // let today = new Date('2020-05-02T00:00:00Z');
        // let date = new Date('2020-01-01T00:00:00Z');
        let today = new Date();
        let date = new Date(PROJECT_START);
        
        let months = [
            dateToString(date)
        ];
        date = new Date(date.setUTCMonth(date.getUTCMonth() + 1));
        while(date < today){
            months.unshift(dateToString(date));
            date = new Date(date.setUTCMonth(date.getUTCMonth() + 1));
        }
        this.state={
            loading: false,
            months
        }
    }
    componentDidMount(){
        this.fetch_data()
    }

    fetch_data = async(refresh?:boolean) => {
        if(refresh) this.setState({ loading: true })
        try {
            await this.fetch_kpi_definitions()
            await this.fetch_performance_data()
            await this.fetch_kpi_data()
        }
        catch (e) {
        }
        finally {
            // this.setState({ loading: false })
            if(refresh) this.setState({ loading: false });
        }
    }
    fetch_kpi_definitions = async() => {
        try {
            let res = await request(`${API_URL}/api/v1/kpi_definitions`,{
                method:'get',
                params:{
                    orderby:'id asc'
                }
            })
            this.setState({ kpi_definitions: res.data.value });
        }
        catch (e) {
            axiosErrorHandler( e, { functionName: 'fetch_kpi_definitions_data' })
        }
    }
    fetch_performance_data = async() => {
        try {
            let res = await request(`${API_URL}/api/v1/kpi_performance_levels`,{
                method:'get',
                params:{
                    limit: 1000,
                }
            })

            // organise each performance level by kpi
            let kpi_performance_levels:any = {};
            for(let d of res.data.value){
                if(!(d.kpi_definition in kpi_performance_levels))
                    kpi_performance_levels[d.kpi_definition] = [];
                kpi_performance_levels[d.kpi_definition].push(d);
            }
            // ORDER DATA BY LEVEL
            for(let l in kpi_performance_levels)
                kpi_performance_levels[l] = kpi_performance_levels[l].sort((a:any, b:any)=>{ return b.level > a.level } );
            
            // console.log('kpi_performance_levels',kpi_performance_levels)

            await this.setState({ kpi_performance_levels });
        }
        catch (e) {
            axiosErrorHandler( e, { functionName: 'fetch_performance_data' })
        }
    }
    fetch_kpi_data = async() => {
        let { kpi_performance_levels } = this.state;
        if(!kpi_performance_levels) throw 'Kpi performance levels data required.';
        try {
            let res = await request(`${API_URL}/api/v1/kpis`,{
                method:'get',
                params:{
                    limit: 1000,
                }
            })
            let kpis:any = {};
            for(let d of res.data.value){
                let date = dateToString(new Date(d.date_time));
                // let date = (new Date(d.date_time)).toISOString().split('T')[0];
                if(!(date in kpis))
                    kpis[date] = [];
                let index = KPI_ORDER.indexOf(d.kpi_definition);
                kpis[date][index] = format_kpi(d, kpi_performance_levels);
            }
            
            // console.log('kpis',kpis)

            // let dates = Object.keys(kpis)
            // .sort((a:string, b:string)=>{ return new Date(b).getTime() - new Date(a).getTime() } );
            // .map((d)=>{ return dateToString(d) });

            await this.setState({ kpis });
        }
        catch (e) {
            axiosErrorHandler( e, { functionName: 'fetch_kpi_data' })
        }
    }

    render(){
        let data:any = _data;

        return (
        <Page 
            id="kpi-page"
            title="KPI"
            footer={<Footer/>}
            banner={{
                bannerImage: kpiBanner,
                topBar:{
                    routes: routes,
                    logo: logo,
                }
            }}
        >
            <div className="page-content">
                <div className="centered-content padding">
                    <Tabs
                        tabs={[
                            {
                                label: <><i className="fas fa-chart-pie"/> KPI</>,
                                content: <div className="kpi-tab">
                                    {
                                        this.state.loading ?
                                            <div className="centered padding"><Spinner/></div>
                                        :
                                            this.state.kpis && this.state.kpi_performance_levels &&
                                            <KPIList 
                                                months={this.state.months}
                                                kpi_definitions={this.state.kpi_definitions} 
                                                kpis={this.state.kpis} 
                                                kpi_performance_levels={this.state.kpi_performance_levels}
                                            />
                                    }
                                </div>
                            },
                            {
                                label: <><i className="fas fa-list"/> History</>,
                                content: <div className="kpi-tab">
                                    {
                                        this.state.loading ?
                                            <div className="centered padding"><Spinner/></div>
                                        :
                                            this.state.kpis && this.state.kpi_performance_levels &&
                                            <KPIHistory 
                                                months={this.state.months}
                                                kpi_definitions={this.state.kpi_definitions} 
                                                kpis={this.state.kpis} 
                                                kpi_performance_levels={this.state.kpi_performance_levels}
                                            />
                                    }
                                </div>
                            }
                        ]}
                    />
                </div>
            </div>
        </Page>
        );
    }


};